// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ImageZoomOnHover{max-width:100%;position:relative;text-align:center;z-index:1}.ImageZoomOnHover--center{margin:auto}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.ImageZoomOnHover--center{margin:0}}.ImageZoomOnHover__image{max-height:100%;max-width:100%;opacity:1}.ImageZoomOnHover__zoom{opacity:0;position:absolute;top:0;transform-origin:top left}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
